import { CardCvcElement, CardElement, CardExpiryElement, CardNumberElement, IdealBankElement, useElements, useStripe } from "@stripe/react-stripe-js";
import React,{useMemo} from "react";
import withRouter from "../../withRouter";
import useResponsiveFontSize from "./useResponsiveFontSize";


const useOptions = () => {
    const fontSize = useResponsiveFontSize();
    const options = useMemo(
      () => ({
        style: {
          base: {
            fontSize,
            color: "#424770",
            letterSpacing: "0.025em",
            fontFamily: "Source Code Pro, monospace",
            "::placeholder": {
              color: "#aab7c4"
            }
          },
          invalid: {
            color: "#9e2146"
          }
        }
      }),
      [fontSize]
    );
  
    return options;
  };

//   checkcardNumber = (data) => {
//     console.log(data)
//   }

const SetupIntent = () => {
    const stripe = useStripe();
    const elements = useElements();
    const options = useOptions();
    const handleSubmit = async event => {
        event.preventDefault();
        if (!stripe || !elements) {
          return;
        }
        console.log(elements.getElement(CardNumberElement));
      };
    return (
        <form onSubmit={handleSubmit}>
             <label htmlFor="bank">
               Bank
                <div className="StripeElement">
                <IdealBankElement id="bank"
                    options={options}
                    onReady={() => {
                        console.log("CardNumberElement [ready]");
                    }}
                    onChange={(e,event) => {
                        console.log("CardNumberElement [change]",'e', e,'event',event);
                    }}
                    onBlur={() => {
                        console.log("CardNumberElement [blur]");
                    }}
                    onFocus={() => {
                        console.log("CardNumberElement [focus]");
                    }}
                />
                </div>
            </label>
            <label htmlFor="cardNumber">
                Card number
                <div className="StripeElement">
                <CardNumberElement id="cardNumber"
                    options={options}
                    onReady={() => {
                        console.log("CardNumberElement [ready]");
                    }}
                    onChange={(event) => {
                        // this.checkcardNumber(event)
                        console.log("CardNumberElement [change]",event);
                    }}
                    onBlur={() => {
                        console.log("CardNumberElement [blur]");
                    }}
                    onFocus={() => {
                        console.log("CardNumberElement [focus]");
                    }}
                />
                </div>
            </label>
            <label htmlFor="expiryDate">
                Expiration date
                <div className="StripeElement">
                <CardExpiryElement id="expiryDate"
                    options={options}
                    onReady={() => {
                        console.log("CardNumberElement [ready]");
                    }}
                    onChange={event => {
                        console.log("CardNumberElement [change]", event);
                    }}
                    onBlur={() => {
                        console.log("CardNumberElement [blur]");
                    }}
                    onFocus={() => {
                        console.log("CardNumberElement [focus]");
                    }}
                />
                </div>
            </label>
            <label htmlFor="cvc">
                CVC
                <div className="StripeElement">
                <CardCvcElement id="cvc"
                    options={options}
                    onReady={() => {
                        console.log("CardNumberElement [ready]");
                    }}
                    onChange={event => {
                        console.log("CardNumberElement [change]", event);
                    }}
                    onBlur={() => {
                        console.log("CardNumberElement [blur]");
                    }}
                    onFocus={() => {
                        console.log("CardNumberElement [focus]");
                    }}
                />
                </div>
            </label>
            <button type="submit" disabled={!stripe}>
                Pay
            </button>
        </form>
    );
}

export default withRouter(SetupIntent);